import { AnswerStep } from '../types/chatTypes'

// Runtime tool names, mirrored from the backend.
export const GRAPH_SEARCH_TOOL_PREFIX = 'graph_search_'
export const CLARIFICATION_TOOL_NAME = 'ask_clarification'
export const INTERNET_SEARCH_TOOL_NAME = 'internet_search'

export const isGraphTool = (name: string): boolean =>
  name.startsWith(GRAPH_SEARCH_TOOL_PREFIX) || name === CLARIFICATION_TOOL_NAME

const DOCUMENT_TOOLS = ['relevant_document_chunks_retriever', 'complete_document_retriever', 'table_data_retriever']

/** The status-line step a running tool stands for; none for quick or unknown tools. */
export const toolStep = (name: string, args?: Record<string, unknown>): AnswerStep | undefined => {
  // The queries are checked (and maybe shown for approval) first; `tool_progress` says when they leave.
  if (name === INTERNET_SEARCH_TOOL_NAME) return { kind: 'checking' }
  if (name.startsWith('retrieve_knowledge'))
    return { kind: 'knowledge', items: typeof args?.query === 'string' ? [args.query] : [] }
  if (DOCUMENT_TOOLS.includes(name)) return { kind: 'document' }
  if (name === 'inspect_image') return { kind: 'image' }
  if (name.startsWith(GRAPH_SEARCH_TOOL_PREFIX)) return { kind: 'graph' }
  return undefined
}

/** The i18n key family for a graph tool's step label, whatever the source key after the prefix. */
export const graphToolLabelFamily = (name: string): 'graph_search' | 'ask_clarification' =>
  name === CLARIFICATION_TOOL_NAME ? 'ask_clarification' : 'graph_search'
